import React, { useState, useEffect } from 'react';
import topics from '../../tickertopics.json';

interface TickerProps {
  onItemClick: (item: string) => void;
}

const NewTicker: React.FC<TickerProps> = ({ onItemClick }) => {
  const [isPaused, setIsPaused] = useState(false);
  const [tickerItems, setTickerItems] = useState<string[]>([]);

  useEffect(() => {
    if (!topics || !Array.isArray(topics) || topics.length === 0) {
      setTickerItems([]);
      return;
    }
    const randomTopics = [...topics].sort(() => 0.5 - Math.random()).slice(0, 25);
    setTickerItems(randomTopics);
  }, []);

  if (!tickerItems || tickerItems.length === 0) return null;

  return (
    <div
      className="relative w-full overflow-hidden py-4"
      // Fade edges via CSS mask (supported in modern browsers)
      style={{
        WebkitMaskImage:
          'linear-gradient(to right, transparent 0, black 60px, black calc(100% - 60px), transparent 100%)',
        maskImage:
          'linear-gradient(to right, transparent 0, black 60px, black calc(100% - 60px), transparent 100%)',
      }}
    >
      <div
        className="absolute inset-0 flex items-center whitespace-nowrap" // out of flow + no wrap
        onMouseEnter={() => setIsPaused(true)}
        onMouseLeave={() => setIsPaused(false)}
        style={{
          animation: 'scroll-left 40s linear infinite',
          animationPlayState: isPaused ? 'paused' : 'running',
          willChange: 'transform',
        }}
      >
        {[...Array(3)].map((_, idx) => (
          <div key={idx} className="flex whitespace-nowrap">
            {tickerItems.map((item, i) => (
              <button
                key={`${idx}-${i}-${item}`}
                type="button"
                className="flex-none mx-4 cursor-pointer text-sm px-6 py-3 bg-white rounded-full shadow-sm border border-gray-100 hover:shadow-md hover:border-blue-200 transition-all duration-300 hover:scale-105 font-medium text-gray-700 hover:text-blue-600"
                onClick={() => onItemClick(item)}
                style={{ fontFamily: '"Noto Sans Devanagari", sans-serif' }}
              >
                {item}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default NewTicker;